var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MTimePicker',_vm._g(_vm._b({attrs:{"value":_vm.innerValue},on:{"change":_vm.handleChange}},'MTimePicker',_vm.$attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }